import {
  SEO_ACCELERATOR_LINKS_PER_MONTH,
  SEO_ACCELERATOR_MONTHS,
  SEO_ARTICLES_DOUBLE_MONTHLY_PRICE_MINOR,
  SEO_BACKLINK_ACCELERATOR_PRICE_MINOR,
  SEO_EXTRA_BACKLINK_MAX_QUANTITY,
  SEO_EXTRA_BACKLINK_MONTHLY_PRICE_MINOR,
  SEO_MAX_BACKLINKS_PER_MONTH,
} from '../../subscription-seo-pack.constants';

/**
 * Chiffres du pack référencement cités par les fiches `marketing.seo_pack.*` — dérivés des mêmes
 * constantes que `ADDONS` / `TOPUPS` (`subscription-seo-pack.constants.ts`), jamais recopiés : un
 * prix qui change là-bas change dans la doc et chez Pulse au build suivant.
 *
 * On importe le fichier de constantes et PAS `subscription.ts` : les manifestes sont chargés par le
 * générateur du centre d'aide avec le seul `node_modules` de docs-site, sans `@sinclair/typebox`
 * (job CI `docs-site` cassé le 23/10/2026). Garde-fou : `feature-manifest.spec.ts`.
 */
const eurHt = (minor: number): string => `${minor / 100} € HT`;

export const SEO_PACK_PRICING = {
  articles_double: eurHt(SEO_ARTICLES_DOUBLE_MONTHLY_PRICE_MINOR),
  extra_backlink: eurHt(SEO_EXTRA_BACKLINK_MONTHLY_PRICE_MINOR),
  extra_backlink_max: SEO_EXTRA_BACKLINK_MAX_QUANTITY,
  accelerator: eurHt(SEO_BACKLINK_ACCELERATOR_PRICE_MINOR),
  accelerator_links_per_month: SEO_ACCELERATOR_LINKS_PER_MONTH,
  accelerator_months: SEO_ACCELERATOR_MONTHS,
  max_backlinks_per_month: SEO_MAX_BACKLINKS_PER_MONTH,
} as const;
